import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const settingsRoutes: AppRoute[] = [
  {
    path: paths.app.settings.profile.path,
    permissions: paths.app.settings.profile.permissions,
    page: lazy(() => import("@/pages/settings/profile").then((module) => ({ default: module.SettingsProfile }))),
  },
];
